export const environment = {
  production: true,
  enrollmentUrl: "https://enroll.edtell.com",
};

// This is the backend after it has been deployed
export const apiURL = "https://srs-api.edtell.com"; // Docker replaces this during the image build
export const agGridKey =
  "CompanyName=edtell,LicensedGroup=edtell-multi-developer-license,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-013168,ExpiryDate=26_February_2022_[v2]_MTY0NTgzMzYwMDAwMA==7b04fd63ccdbcabb85e45f2231f35a04";
export const openProgramFormInNewTab = true;
